import {IEnvironment} from "./i-environment";

export const environment: IEnvironment = {
  development: false,
  production: true,
  api: {
    authentication: {
      useSSL: true,
      url: "api.zaeper.com/auth"
    },
    application: {
      useSSL: true,
      url: "api.zaeper.com/application"
    },
    user: {
      useSSL: true,
      url: "api.zaeper.com/developer-user"
    },
    billing: {
      useSSL: true,
      url: "api.zaeper.com/developer-billing"
    },
    registry: {
      useSSL: true,
      url: "api.zaeper.com/registry"
    }
  },
  sites: {
    authentication: {
      useSSL: true,
      url: "auth.zaeper.com"
    },
    userDashboard: {
      useSSL: true,
      url: "dashboard.zaeper.com"
    },
    vendorDashboard: {
      useSSL: true,
      url: "vendor.zaeper.com"
    },
    businessPortalDashboard: {
      useSSL: true,
      url: "business-portal.zaeper.com"
    }
  }
};
